import { createTheme } from "@mui/material/styles";

export const DefaultTheme = createTheme({
	components: {
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					"& .MuiOutlinedInput-notchedOutline": {
						border: `1px solid #CCC`,
					},
					"&.Mui-focused": {
						"& .MuiOutlinedInput-notchedOutline": {
							border: `2px solid #6257FF`,
						},
					},
					"&.Mui-disabled": {
						"& .MuiOutlinedInput-notchedOutline": {
							border: `1px solid #CCC`, // Dashed border when disabled
						},
						color: "#A0A0A0", // Gray text color when disabled
					}
				},
				input: {
					textAlign: "left",
					"&:-webkit-autofill": {
						boxShadow: "0 0 0 1000px rgba(0,0,0,0) inset",
						transition: "background-color 9999s ease-out, color 9999s ease-out",
					},
				},
			}
		},
		MuiInputLabel: {
			styleOverrides: {
				outlined: {
					'&.MuiInputLabel-shrink': {
						color: "black"
					},
				},
			},
		}
	}
});
